import api from './api';

/**
 * Credit Package Service
 * Handles all credit package-related API calls
 * Phase 7: Credit System
 */
const creditPackageService = {
  /**
   * Get all packages (admin - includes inactive)
   * @param {Object} filters - {isActive}
   * @returns {Promise<CreditPackage[]>}
   */
  getPackages: async (filters = {}) => {
    const { isActive } = filters;
    const queryParams = new URLSearchParams();
    
    if (isActive !== undefined) {
      queryParams.append('isActive', isActive);
    }
    
    const response = await api.get(`/credit-packages?${queryParams}`);
    return response.data.data; // Array of packages
  },

  /**
   * Get active packages only (public - no authentication required)
   * @returns {Promise<CreditPackage[]>}
   */
  getActivePackages: async () => {
    const response = await api.get('/credit-packages/active');
    return response.data.data; // Array of active packages
  },

  /**
   * Get package by ID
   * @param {string} packageId - Package ID
   * @returns {Promise<CreditPackage>}
   */
  getPackage: async (packageId) => {
    const response = await api.get(`/credit-packages/${packageId}`);
    return response.data.data; // Package object
  },

  /**
   * Create a new credit package
   * @param {Object} data - {name, credits, price, bonusCredits, order, description}
   * @returns {Promise<CreditPackage>}
   */
  createPackage: async (data) => {
    const response = await api.post('/credit-packages', data);
    return response.data.data; // New package
  },

  /**
   * Update an existing credit package
   * @param {string} packageId - Package ID
   * @param {Object} data - {name?, credits?, price?, bonusCredits?, isActive?, order?, description?}
   * @returns {Promise<CreditPackage>}
   */
  updatePackage: async (packageId, data) => {
    const response = await api.put(`/credit-packages/${packageId}`, data);
    return response.data.data; // Updated package
  },

  /**
   * Delete a credit package (soft delete)
   * @param {string} packageId - Package ID
   * @returns {Promise<{message: string}>}
   */
  deletePackage: async (packageId) => {
    const response = await api.delete(`/credit-packages/${packageId}`);
    return response.data; // { success, message }
  }
};

export default creditPackageService;

